import {trigger} from "../../../utils/events/trigger";

export const initHash = () => {
	window.addEventListener(`hashchange`, (evt) => {
		const hash = location.hash.split( `/` );
	});

	trigger(window, `hashchange`);
};
